module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "flexContainer fd-c",
    attrs: {
      "id": "commentContent"
    }
  }, [_c('div', {
    staticClass: "commentList f-00"
  }, _vm._l((_vm.comments), function(comment) {
    return _c('div', {
      key: comment.id,
      staticClass: "flexContainer fd-c ac-c mt25"
    }, [_c('div', {
      staticClass: "flexContainer fd-r"
    }, [_c('div', {
      staticClass: "userInfo"
    }, [_vm._v(_vm._s(comment.createdUser.initial))]), _vm._v(" "), _c('div', {
      staticClass: "commentInfo full"
    }, [_c('span', {
      staticClass: "bold fleft"
    }, [_vm._v(_vm._s(comment.createdUser.firstname) + " " + _vm._s(comment.createdUser.lastname))]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "fleft"
    }, [_vm._v(_vm._s(comment.content))]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n                        " + _vm._s(comment.createdAt) + "\n                    ")])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "flexContainer full fd-c commentArea"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newComment.content),
      expression: "newComment.content"
    }],
    staticClass: "full",
    attrs: {
      "id": "commentZone",
      "rows": "8",
      "placeholder": "Your comment"
    },
    domProps: {
      "value": (_vm.newComment.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newComment.content = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rel"
  }, [_c('button', {
    staticClass: "btn abs pointer sendComment txtCenter",
    on: {
      "click": _vm.sendComment
    }
  }, [_vm._v(_vm._s(_vm.$t("comments.send")))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-705c40be","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plano/menu/Comments.vue
// module id = 3260
// module chunks = 0